
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interaction/[interactionId]",
      function () {
        return require("private-next-pages/interaction/[interactionId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interaction/[interactionId]"])
      });
    }
  